import React from 'react';
import { AccountCircleSharp } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";

const Home = () => {
  const theme = useTheme();
  const userInfo: any = sessionStorage.getItem('userInfo');
  const userInfoObj: any = userInfo && JSON.parse(userInfo);
  
  return (
    <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
      <Typography
        variant="h3"
        fontWeight={"bold"}
        mt={3}
        color={theme.palette.primary.contrastText}
      >
        Welcome
      </Typography>
      <Box
        borderRadius={50}
        padding={0}
        display={"flex"}
        mt={4}
        mb={4}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ backgroundColor: theme.palette.grey[500] }}
      >
        <AccountCircleSharp
          sx={{
            fontSize: "150px",
            color: theme.palette.primary.contrastText,
            margin: 0,
          }}
        />
      </Box>
      <Typography variant="h4" fontWeight={"bold"}>
        {userInfoObj?.username}
      </Typography>
      <Typography variant="h4" fontWeight={"bold"}>
        {userInfoObj?.email}
      </Typography>
    </Box>
  );
};

export default Home;
